import { tw } from "@careinfo/tailwind";
import loadable from "@loadable/component";
const SalesReturnRegisterComponent = loadable(
  () => import("../../components/CBMSReports/SalesReturnRegister")
);

const SalesReturnRegister = () => {
  return (
    <>
      <div className={tw`grid grid-cols-2 `}>
        <h1 className={tw`font-semibold text-xl leading-10`}>
          Sales Return Register
        </h1>
      </div>
      <SalesReturnRegisterComponent />
    </>
  );
};

export default SalesReturnRegister;
